import { getFeesForPaymentOptions } from "@/hera-api/client/@tanstack/react-query.gen";
import { getLicenseTypeConfigurationOptions } from "@/hera-api/client/@tanstack/react-query.gen";
import { useAuthQuerySetup } from "@/hooks/use-auth-query-setup";
import { useQuery } from "@tanstack/react-query";

interface UseLicensePaymentDataOptions {
  licenseId: string;
  licenseTypeId?: string;
  jurisdictionId?: string;
}

export function useLicensePaymentData({
  licenseId,
  licenseTypeId,
  jurisdictionId,
}: UseLicensePaymentDataOptions) {
  const { isAuthSetupComplete } = useAuthQuerySetup();

  // Get fees data for payment (only current and past periods with balances)
  const feesQuery = useQuery({
    ...getFeesForPaymentOptions({
      path: { license_id: licenseId },
    }),
    enabled: isAuthSetupComplete && !!licenseId,
  });

  // Get configuration data
  const configurationQuery = useQuery({
    ...getLicenseTypeConfigurationOptions({
      path: {
        license_type_id: licenseTypeId || "",
        jurisdiction_id: jurisdictionId || "",
      },
    }),
    enabled: isAuthSetupComplete && !!licenseTypeId && !!jurisdictionId,
  });

  return {
    feesData: feesQuery.data,
    configurationData: configurationQuery.data,
    isLoading: feesQuery.isLoading || configurationQuery.isLoading,
    error: feesQuery.error || configurationQuery.error,
  };
}
